import React from 'react';

import { IGradeModel } from '@common/models/GradeBooks/Grade';

import { StyledGradeBookGrade, StyledGradeBookGradesList } from './styled';

interface PropsType {
	grades: IGradeModel[];
	finaleGrade?: string | number;
}

function GradeBookGrades({ grades, finaleGrade }: PropsType) {
	if (!grades?.length && !finaleGrade) return null;

	const renderedGrades = [
		...(finaleGrade ? [{ id: 'finale', grade: finaleGrade, isFinale: true }] : []),
		...(grades || []),
	];

	return (
		<StyledGradeBookGradesList>
			{[...renderedGrades].map((item, index) => {
				if (!item?.grade && item?.grade !== 0) return null;

				const { isFinale } = item as any;
				const backgroundColor = isFinale ? '#99C2FD' : '#71ABFF';

				return (
					<StyledGradeBookGrade
						key={item.id ?? `${item.grade}-${index}`}
						sx={{ backgroundColor, zIndex: renderedGrades.length - index }}
						$offset={index}
					>
						{item.grade}
					</StyledGradeBookGrade>
				);
			})}
		</StyledGradeBookGradesList>
	);
}

export default GradeBookGrades;
